const FONT_SIZE_RX = /font-size--\d+/g
const FONT_WEIGHT_RX = /font-weight--\d+/g
const FONT_COLOR_RX = /color--\w+/g
const LETTER_SPACING_RX = /letter-spacing--\w+/g
const HEADING_RX = /h\d_\w+/g
const BODY_RX = /body\d_\w+/g
const SUB_TITLE_RX = /subtitle\d_\w+/g
const BORDER_RX = /border--\w+/g
const TEXT_ALIGN_RX = /text-align--\w+/g
const TEXT_TRANSFORM_RX = /text-transform--\w+/g
const BACKGROUND_COLOR_RX = /background-color--\w+/g

const RX_TO_REPLACE = [
  FONT_SIZE_RX,
  FONT_WEIGHT_RX,
  FONT_COLOR_RX,
  LETTER_SPACING_RX,
  HEADING_RX,
  BODY_RX,
  SUB_TITLE_RX,
  BORDER_RX,
  TEXT_TRANSFORM_RX,
  TEXT_ALIGN_RX,
  BACKGROUND_COLOR_RX,
]

const mergeClasses = (baseClassNames: string[], classesToMerge: string[]): string => {
  let baseClassNamesString = (baseClassNames || []).join(' ')
  const classesToMergeString = (classesToMerge || []).join(' ')

  RX_TO_REPLACE.forEach((rx: RegExp) => {
    if (classesToMergeString.match(rx)) {
      baseClassNamesString = baseClassNamesString.replaceAll(rx, '')
    }
  })

  return `${baseClassNamesString} ${classesToMergeString}`
}

export default mergeClasses
